import { useCallback } from "react";

import { useIntl } from "react-intl";

import BookletLogo from "images/random/booklet.png";

import { PickingProductCard } from "./PickingProductCard";
import { useRemoveFlyersQuantites } from "../hooks/usePickingMachineSelectors";
import { usePickingStore } from "../stores/usePickingStore";

export function RemoveFlyers() {
  const intl = useIntl();

  const { picked, total } = useRemoveFlyersQuantites();
  const handleClickProductCard = useCallback(() => {
    if (picked === total) {
      return;
    }
    usePickingStore.getState().incrementRemoveFlyersQuantity();
    // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [picked, total]);

  return (
    <PickingProductCard
      itemId="itemId"
      imageUrl={BookletLogo}
      name={intl.formatMessage({ id: "components.picking.remove-flyers.product-card-title" })}
      pickedQuantity={picked}
      totalQuantity={total}
      hasBarcode={false}
      state={picked === total ? "DONE" : "IDLE"}
      onClickProductCard={handleClickProductCard}
      isCrossVisible
    />
  );
}
